import React from "react";
import {TourProvider} from "@reactour/tour";
import { useTour } from '@reactour/tour'

export function useMTour() {
    return useTour()
}

function MTour(props) {
    return (
        <TourProvider
            steps={props.steps}
            showBadge={props.showBadge}
            showNavigation={props.showNavigation}
            showCloseButton={props.showCloseButton}
            className={"rounded-xl text-lg"}
        >
            {props.children}
        </TourProvider>
    );
}

export default MTour;
